export let QueryConfigTypes = /*#__PURE__*/function (QueryConfigTypes) {
  QueryConfigTypes["MUTATION_METHOD"] = "MUTATION_METHOD";
  QueryConfigTypes["REALTIME_DATA"] = "REALTIME";
  QueryConfigTypes["REALTIME_NO_REFETCH"] = "REALTIME_NO_REFETCH";
  QueryConfigTypes["DYNAMIC_DATA"] = "DYNAMIC";
  QueryConfigTypes["MODERATE_DATA"] = "MODERATE_DATA";
  QueryConfigTypes["STATIC_DATA"] = "STATIC";
  QueryConfigTypes["FIXED_DATA"] = "FIXED";
  return QueryConfigTypes;
}({});

// porting react-query fetch options

export let RPC_STATUS_CODES = /*#__PURE__*/function (RPC_STATUS_CODES) {
  RPC_STATUS_CODES[RPC_STATUS_CODES["OK"] = 0] = "OK";
  RPC_STATUS_CODES[RPC_STATUS_CODES["INVALID_ARGUMENT"] = 3] = "INVALID_ARGUMENT";
  RPC_STATUS_CODES[RPC_STATUS_CODES["NOT_FOUND"] = 5] = "NOT_FOUND";
  RPC_STATUS_CODES[RPC_STATUS_CODES["ALREADY_EXISTS"] = 6] = "ALREADY_EXISTS";
  RPC_STATUS_CODES[RPC_STATUS_CODES["PERMISSION_DENIED"] = 7] = "PERMISSION_DENIED";
  RPC_STATUS_CODES[RPC_STATUS_CODES["ABORTED"] = 10] = "ABORTED";
  RPC_STATUS_CODES[RPC_STATUS_CODES["UNIMPLEMENTED"] = 12] = "UNIMPLEMENTED";
  RPC_STATUS_CODES[RPC_STATUS_CODES["INTERNAL"] = 13] = "INTERNAL";
  RPC_STATUS_CODES[RPC_STATUS_CODES["UNAVAILABLE"] = 14] = "UNAVAILABLE";
  RPC_STATUS_CODES[RPC_STATUS_CODES["UNAUTHENTICATED"] = 16] = "UNAUTHENTICATED";
  return RPC_STATUS_CODES;
}({});
//# sourceMappingURL=common.js.map